const styles = {
  list: {
    borderRadius: "5px 5px 5px 5px",
    border: "1px solid #C2D4EB",
    background: "#F6F6F6",
    padding: "20px 0px 20px 20px",
    borderBottom: "9px solid #196AAB",
    margin: "0px 20px",
  },
  listItem: {
    marginBottom: "14px",
  },
};

export default styles;
